import React from 'react';
import { withRouter, Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

import { urls } from '@/constants';

import ScrollToTop from '@/components/ScrollToTop';

import Loading from '@/components/Loading';
import If from '@/components/If';
import ConsumeRedirectRoute from '@/components/Navigation/ConsumeRedirectRoute';
import RedirectWithPersist from '@/components/Navigation/RedirectWithPersist';
import { SessionConsumer } from './components/Context/Session';
import { Toaster } from '@/components/ui/sonner';

import './styles/globals.css';

const HomePage = React.lazy(() => import('@/page/HomePage'));
const Public = React.lazy(() => import('./page/Public'));

export interface Props extends RouteComponentProps {}

const App: React.FC<Props> = () => {
  return (
    <ScrollToTop>
      <SessionConsumer>
        {({ loading, error, session, me }) => (
          <React.Fragment>
            <Loading visible={loading} />

            <If
              condition={!loading}
              then={() => (
                <If
                  condition={!error}
                  then={() => (
                    <If
                      condition={session && me}
                      then={() => (
                        <React.Suspense fallback={<Loading visible />}>
                          <Switch>
                            <Route path={urls.home} component={HomePage} />
                            <ConsumeRedirectRoute render={() => <Redirect to={urls.home} />} />
                          </Switch>
                        </React.Suspense>
                      )}
                      else={() => (
                        <React.Suspense fallback={<Loading visible />}>
                          <Switch>
                            <Route path={urls.home} component={Public} />
                            <ConsumeRedirectRoute render={() => <RedirectWithPersist to={urls.signIn} />} />
                          </Switch>
                        </React.Suspense>
                      )}
                    />
                  )}
                />
              )}
            />
            <Toaster richColors />
          </React.Fragment>
        )}
      </SessionConsumer>
    </ScrollToTop>
  );
};

export default withRouter(App);
